import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { NgChartsModule } from 'ng2-charts';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { chartColorsList } from '../shared/variables/chartColorsList';
import { CustomerMasterApiService } from '../CommonController/customer-master-service';
import { DeviceModelApiService } from '../CommonController/device-model-api-service';
import { DeviceApiService } from '../CommonController/device-api-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-device-dashboard-page',
  templateUrl: './device-dashboard-page.component.html',
  styleUrls: ['./device-dashboard-page.component.scss'],
  standalone: true,
  imports: [
    NgChartsModule,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    CommonSearchComponent,
    CommonPaginationComponent,
    NgxPaginationModule,
    CommonDropdownSearchComponent,
  ],
})
export class DeviceDashboardPageComponent implements OnInit {
  @ViewChild('tableContainer') MyProp!: ElementRef;
  selectedPageTitle = 'Total Production Devices';

  pageSize = 10;
  currentPage = 1;
  totalCount = 0;
  totalPage = 0;
  searchText = '';
  selectedDeviceModelId = '';
  selectedCustomerId = '';
  deviceDetailsList = [];
  exportData = [];

  productionDevice = 0;
  dispatchedCount = 0;
  installedCount = 0;
  discardedCount = 0;

  graphForm: FormGroup;

  userPermissions = [];
  Device_dashboardView = false;
  deviceActivityOverviewBarChartData = {
    labels: [],
    datasets: [
      {
        label: 'Count',
        data: [],
        backgroundColor: chartColorsList,
        borderColor: chartColorsList,
        borderWidth: 1,
      },
    ],
  };
  firmwareWiseDeviceBarChartData = {
    labels: [],
    datasets: [
      {
        label: 'Count',
        data: [],
        backgroundColor: chartColorsList,
        borderColor: chartColorsList,
        borderWidth: 1,
      },
    ],
  };

  bootLoaderVersionWiseDeviceBarChartData = {
    labels: [],
    datasets: [
      {
        label: 'Count',
        data: [],
        backgroundColor: chartColorsList,
        borderColor: chartColorsList,
        borderWidth: 1,
      },
    ],
  };

  mcuWiseDeviceBarChartData = {
    labels: [],
    datasets: [
      {
        label: 'Count',
        data: [],
        backgroundColor: chartColorsList,
        borderColor: chartColorsList,
        borderWidth: 1,
      },
    ],
  };

  cpuWiseDeviceBarChartData = {
    labels: [],
    datasets: [
      {
        label: 'Count',
        data: [],
        backgroundColor: chartColorsList,
        borderColor: chartColorsList,
        borderWidth: 1,
      },
    ],
  };

  barChartOption = {
    responsive: true,
    maintainAspectRatio: false, // Allows flexible resizing
    scales: {
      x: {
        type: 'category',
        beginAtZero: true,
        grid: {
          display: true,
        },
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 0,
          color: '#666', // Customize label color
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
        },
        ticks: {
          color: '#666', // Customize label color
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Enable legend to verify data binding
      },
      tooltip: {
        enabled: true, // Display tooltips on hover
      },
    },
  };

  // Graph Data
  activeLabel = [
    'Today',
    'Five Days',
    'Ten Days',
    'Fifteen Days',
    'More Than Fifteen',
    'Not Active',
  ];

  firmwareChartLabel = [];
  bootChartLabel = [];
  mcuChartLabel = [];
  cpuChartLabel = [];

  activityOverviewFilter = [
    { key: 'All', value: 'All' },
    { key: 'Today', value: 'TODAY' },
    { key: 'Five Days', value: 'FIVE_DAYS' },
    { key: 'Ten Days', value: 'TEN_DAYS' },
    { key: 'Fifteen Days', value: 'FIFTEEN_DAYS' },
    { key: 'More Than Fifteen', value: 'MORE_THAN_FIFTEEN_DAYS' },
    { key: 'Not Active', value: 'NOT_ACTIVE' },
  ];
  customerNameList = [];
  deviceModelNameList = [];
  firmwareNamesList = [];
  bootNamesList = [];
  mcuNamesList = [];
  cpuNamesList = [];

  headerlist = [
    {
      'Total Production Devices': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID NO.',
        'Model Name.',
      ],
      'Total Dispatched Devices': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID NO.',
        'Model Name.',
        'Customer Name',
      ],
      'Total Installed Devices': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID NO.',
        'CHASSIS NO.',
        'Model Name.',
        'Customer Name',
      ],
      'Total Discarded Devices': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID NO.',
        'CHASSIS NO.',
        'Model Name.',
        'INSTALLED AT',
        'DISCARDED AT',
      ],
      'Device Activity Overview': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID NO.',
        'Model Name.',
        'Log In Time',
      ],
      'Firmware Wise Devices': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID.',
        // 'Model Name.',
        'VERSION.',
      ],
      'Boot loader Version Wise Devices': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID.',
        // 'Model Name.',
        'BOOT VERSION.',
        'MCU VERSION.',
        'CPU VERSION.',
      ],
      'MCU Version Wise Devices': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID.',
        // 'Model Name.',
        'BOOT VERSION.',
        'MCU VERSION.',
        'CPU VERSION.',
      ],
      'CPU Version Wise Devices': [
        'UIN NO.',
        'IMEI NO.',
        'ICCID.',
        // 'Model Name.',
        'BOOT VERSION.',
        'MCU VERSION.',
        'CPU VERSION.',
      ],
    },
  ];
  headerlistValue = [
    {
      'Total Production Devices': ['uid', 'imei', 'iccid', 'modelName'],
      'Total Dispatched Devices': [
        'uid',
        'imei',
        'iccid',
        'modelName',
        'customerName',
      ],
      'Total Installed Devices': [
        'uid',
        'imei',
        'iccid',
        'chassisNo',
        'modelName',
        'customerName',
      ],
      'Total Discarded Devices': [
        'uid',
        'imei',
        'iccid',
        'chassisNo',
        'modelName',
        'installedAt',
        'discardedAt',
      ],
      'Device Activity Overview': [
        'uid',
        'imei',
        'iccid',
        'modelName',
        'login',
      ],
      'Firmware Wise Devices': [
        'uin',
        'imei',
        'iccid',
        // 'modelName',
        'deviceFirmware',
      ],
      'Boot loader Version Wise Devices': [
        'uin',
        'imei',
        'iccid',
        // 'modelName',
        'bootVersion',
        'mcuVersion',
        'cpuVersion',
      ],
      'MCU Version Wise Devices': [
        'uin',
        'imei',
        'iccid',
        // 'modelName',
        'bootVersion',
        'mcuVersion',
        'cpuVersion',
      ],
      'CPU Version Wise Devices': [
        'uin',
        'imei',
        'iccid',
        // 'modelName',
        'bootVersion',
        'mcuVersion',
        'cpuVersion',
      ],
    },
  ];

  projectName = environment.projectName;

  constructor(
    public router: Router,
    public formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public deviceApiService: DeviceApiService,
    public customerMasterApiService: CustomerMasterApiService,
    public deviceModelApiService: DeviceModelApiService,
    public commonApiService: CommonApiService,
    public spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setDeviceDashboardForm();
    this.selectedPageTitle = sessionStorage.getItem('deviceDashboardListType');
    if (
      this.selectedPageTitle === '' ||
      this.selectedPageTitle === null ||
      this.selectedPageTitle === undefined
    ) {
      this.selectedPageTitle = 'Total Production Devices';
    }
    this.getCustomerNameList();
    this.getDeviceModelNameList();
    this.getDeviceDashboardKPICount();
    this.getDeviceDashboardGraphDetails();
    this.fetchDeviceList(this.selectedPageTitle);
  }

  checkPermission() {
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.userPermissions.forEach((element) => {
      if (element.pageName === 'Dashboard' && element.view === true) {
        this.Device_dashboardView = true;
      }
    });
  }

  setDeviceDashboardForm() {
    this.graphForm = this.formBuilder.group({
      searchProducedDevices: new FormControl(''),
      searchDispatchedDevices: new FormControl(''),
      searchInstalledDevices: new FormControl(''),
      searchDiscardedDevices: new FormControl(''),
      searchDevicesNotActiveFrom: new FormControl(''),
      searchFirmwareWisedetails: new FormControl(''),
      searchBootVersionWiseDetails: new FormControl(''),
      searchMcuVersionWiseDetails: new FormControl(''),
      searchCpuVersionWiseDetails: new FormControl(''),
      devicesNotActiveSortBy: new FormControl(''),
      firmwareWiseSortBy: new FormControl(''),
      selectedCustomerId: new FormControl(''),
      selectedDeviceModelId: new FormControl(''),
    });

    this.graphForm
      .get('selectedCustomerId')
      ?.patchValue(
        sessionStorage.getItem('selectedCustomerId')
          ? Number(sessionStorage.getItem('selectedCustomerId'))
          : ''
      );

    this.selectedCustomerId = this.graphForm.get('selectedCustomerId')?.value;

    this.graphForm
      .get('selectedDeviceModelId')
      ?.patchValue(
        sessionStorage.getItem('selectedDeviceModelId')
          ? Number(sessionStorage.getItem('selectedDeviceModelId'))
          : ''
      );

    this.selectedDeviceModelId = this.graphForm.get(
      'selectedDeviceModelId'
    )?.value;
  }

  getCustomerNameList() {
    this.customerNameList = [
      {
        key: 'All',
        value: '',
      },
    ];
    this.customerMasterApiService.getAllCustomer(1, 10000, '').subscribe({
      next: (res) => {
        res.data.forEach((element) => {
          const item = {
            key: element.customerName,
            value: element.id,
          };
          this.customerNameList.push(item);
        });
        this.customerNameList = [...this.customerNameList];
      },
      error: (ERROR: HttpErrorResponse) => {
        this.customerNameList = [];
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  getDeviceModelNameList() {
    this.deviceModelNameList = [
      {
        key: 'All',
        value: '',
      },
    ];
    this.deviceModelApiService.getDeviceModelList(1, 10000, '').subscribe({
      next: (res) => {
        res.data.forEach((element) => {
          const item = {
            key: element.modelName,
            value: element.modelId,
          };
          this.deviceModelNameList.push(item);
        });
        this.deviceModelNameList = [...this.deviceModelNameList];
      },
      error: (error) => {
        if (error.status === 404) {
          this.deviceModelNameList = []; // Clear the list
          this.commonApiService.openSnackbar(error.error.message);
        } else {
          this.commonApiService.openSnackbar(
            'An error occurred while fetching data.'
          );
        }
      },
    });
  }

  getDeviceDashboardKPICount() {
    this.spinner.show();
    this.deviceApiService
      .countAllDeviceDetails(
        this.selectedDeviceModelId,
        this.selectedCustomerId
      )
      .subscribe({
        next: (res) => {
          if (res.status) {
            this.productionDevice = res.productionDevice;
            this.dispatchedCount = res.dispatchedDevice;
            this.installedCount = res.installedDevice;
            this.discardedCount = res.discardedDevice;
          } else {
            this.productionDevice = 0;
            this.dispatchedCount = 0;
            this.installedCount = 0;
          }
          this.spinner.hide();
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.productionDevice = 0;
          this.dispatchedCount = 0;
          this.installedCount = 0;
          this.commonApiService.openSnackbar(
            ERROR.error?.message || 'Failed to fetch data'
          );
        },
      });
  }

  getDeviceDashboardGraphDetails() {
    this.deviceApiService
      .inActiveGraph(this.selectedDeviceModelId, this.selectedCustomerId)
      .subscribe({
        next: (res) => {
          if (res.status) {
            this.deviceActivityOverviewBarChartData.datasets[0].data = [];
            if (res.data) {
              this.deviceActivityOverviewBarChartData.datasets[0].data = [
                res.data.todaysCount,
                res.data.fiveDaysCount,
                res.data.tenDaysCount,
                res.data.fifteenDaysCount,
                res.data.moreThanFifteenDaysCount,
                res.data.notActiveCount,
              ];

              this.deviceActivityOverviewBarChartData.labels = [
                `${this.activeLabel[0]} ➔ ${res.data.todaysCount}`,
                `${this.activeLabel[1]} ➔ ${res.data.fiveDaysCount}`,
                `${this.activeLabel[2]} ➔ ${res.data.tenDaysCount}`,
                `${this.activeLabel[3]} ➔ ${res.data.fifteenDaysCount}`,
                `${this.activeLabel[4]} ➔ ${res.data.moreThanFifteenDaysCount}`,
                `${this.activeLabel[5]} ➔ ${res.data.notActiveCount}`,
              ];
            } else {
              this.deviceActivityOverviewBarChartData.datasets[0].data = [
                0, 0, 0, 0, 0, 0,
              ];
            }
          } else {
            this.deviceActivityOverviewBarChartData.datasets[0].data = [
              0, 0, 0, 0, 0, 0,
            ];
          }

          this.deviceActivityOverviewBarChartData = this.updateChartData(
            this.deviceActivityOverviewBarChartData.labels,
            this.deviceActivityOverviewBarChartData.datasets[0].data,
            'Count'
          );
        },
        error: (ERROR: HttpErrorResponse) => {
          this.deviceActivityOverviewBarChartData.datasets[0].data = [
            0, 0, 0, 0, 0, 0,
          ];
          this.commonApiService.openSnackbar(
            ERROR.error.message || 'Graph data not fetched'
          );
          this.spinner.hide();
        },
      });

    this.deviceApiService
      .getFirmwareWiseDeviceCount(
        this.selectedDeviceModelId,
        this.selectedCustomerId
      )
      .subscribe({
        next: (res) => {
          if (res.status) {
            this.firmwareChartLabel = [];
            this.bootChartLabel = [];
            this.mcuChartLabel = [];
            this.cpuChartLabel = [];

            this.firmwareNamesList = [{ key: 'All', value: 'All' }];
            this.bootNamesList = [{ key: 'All', value: 'All' }];
            this.mcuNamesList = [{ key: 'All', value: 'All' }];
            this.cpuNamesList = [{ key: 'All', value: 'All' }];

            this.firmwareWiseDeviceBarChartData.datasets[0].data = [];
            this.bootLoaderVersionWiseDeviceBarChartData.datasets[0].data = [];
            this.mcuWiseDeviceBarChartData.datasets[0].data = [];
            this.cpuWiseDeviceBarChartData.datasets[0].data = [];

            if (res.data.length > 0) {
              res.data.forEach((element) => {
                if (element.firmwareVersion) {
                  const item = {
                    key: element.firmwareVersion,
                    value: element.firmwareVersion,
                  };
                  this.firmwareNamesList.push(item);
                  this.firmwareChartLabel.push(
                    `${element.firmwareVersion} ➔ ${element.count}`
                  );

                  this.firmwareWiseDeviceBarChartData.datasets[0].data.push(
                    element.count
                  );
                }

                // Bootloader
                if (element.bootVersion) {
                  const bootItem = {
                    key: element.bootVersion,
                    value: element.bootVersion,
                  };
                  this.bootNamesList.push(bootItem);
                  this.bootChartLabel.push(
                    `${element.bootVersion} ➔ ${element.count}`
                  );
                  this.bootLoaderVersionWiseDeviceBarChartData.datasets[0].data.push(
                    element.count
                  );
                }

                // MCU
                if (element.mcuVersion) {
                  const mcuItem = {
                    key: element.mcuVersion,
                    value: element.mcuVersion,
                  };
                  this.mcuNamesList.push(mcuItem);
                  this.mcuChartLabel.push(
                    `${element.mcuVersion} ➔ ${element.count}`
                  );
                  this.mcuWiseDeviceBarChartData.datasets[0].data.push(
                    element.count
                  );
                }

                // CPU
                if (element.cpuVersion) {
                  const cpuItem = {
                    key: element.cpuVersion,
                    value: element.cpuVersion,
                  };
                  this.cpuNamesList.push(cpuItem);
                  this.cpuChartLabel.push(
                    `${element.cpuVersion} ➔ ${element.count}`
                  );
                  this.cpuWiseDeviceBarChartData.datasets[0].data.push(
                    element.count
                  );
                }
              });
            }
          } else {
            this.firmwareWiseDeviceBarChartData.datasets[0].data = [];
            this.bootLoaderVersionWiseDeviceBarChartData.datasets[0].data = [];
            this.mcuWiseDeviceBarChartData.datasets[0].data = [];
            this.cpuWiseDeviceBarChartData.datasets[0].data = [];
          }

          // Firmware chart
          this.firmwareWiseDeviceBarChartData = this.updateChartData(
            this.firmwareChartLabel,
            this.firmwareWiseDeviceBarChartData.datasets[0].data,
            'Count'
          );

          // Bootloader chart
          this.bootLoaderVersionWiseDeviceBarChartData = this.updateChartData(
            this.bootChartLabel,
            this.bootLoaderVersionWiseDeviceBarChartData.datasets[0].data,
            'Count'
          );

          // MCU chart
          this.mcuWiseDeviceBarChartData = this.updateChartData(
            this.mcuChartLabel,
            this.mcuWiseDeviceBarChartData.datasets[0].data,
            'Count'
          );

          // CPU chart
          this.cpuWiseDeviceBarChartData = this.updateChartData(
            this.cpuChartLabel,
            this.cpuWiseDeviceBarChartData.datasets[0].data,
            'Count'
          );
        },
        error: (ERROR: HttpErrorResponse) => {
          this.firmwareWiseDeviceBarChartData.datasets[0].data = [];
          this.bootLoaderVersionWiseDeviceBarChartData.datasets[0].data = [];
          this.mcuWiseDeviceBarChartData.datasets[0].data = [];
          this.cpuWiseDeviceBarChartData.datasets[0].data = [];

          this.commonApiService.openSnackbar(
            ERROR.error.message || 'Graph data not fetched'
          );
          this.spinner.hide();
        },
      });
  }

  updateChartData(
    newLabels: string[],
    newData: (string | number)[],
    modelName: string
  ) {
    return cloneDeep({
      labels: newLabels,
      datasets: [
        {
          label: modelName || 'Unknown',
          data: newData.map((value) => Number(value)),
          backgroundColor: chartColorsList,
          borderColor: chartColorsList,
          borderWidth: 1,
        },
      ],
    });
  }

  fetchDeviceList(listType) {
    setTimeout(() => {
      if (this.MyProp) {
        this.MyProp.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100);
    this.deviceDetailsList = [];
    const previousPageTitle = this.selectedPageTitle;
    this.selectedPageTitle = listType;
    if (
      this.isFirmwareGraph(previousPageTitle) &&
      this.isFirmwareGraph(this.selectedPageTitle) &&
      previousPageTitle !== this.selectedPageTitle
    ) {
      this.clearFirmwareGraphFilter();
    }
    sessionStorage.setItem('deviceDashboardListType', listType);
    this.searchText = this.getSearchValue();
    this.pageSize = this.getSizeChangeValue();
    this.currentPage = this.getPageChangeValue();
    // Call the appropriate method based on `selectedPageTitle`
    switch (this.selectedPageTitle) {
      case 'Total Production Devices':
        this.fetchProductionData();
        break;
      case 'Total Dispatched Devices':
        this.fetchDispatchData();
        break;
      case 'Total Installed Devices':
        this.fetchInstalledData();
        break;
      case 'Total Discarded Devices':
        this.fetchDiscardedData();
        break;
      case 'Device Activity Overview':
        this.fetchDeviceActivityOverviewData();
        break;
      case 'Firmware Wise Devices':
        this.getFirmwareWiseDeviceList();
        break;
      case 'Boot loader Version Wise Devices':
        this.getBootVersionWiseDeviceList();
        break;
      case 'MCU Version Wise Devices':
        this.getMcuVersionWiseDeviceList();
        break;
      case 'CPU Version Wise Devices':
        this.getCpuVersionWiseDeviceList();
        break;
      default:
        console.error('Invalid selectedPageTitle:', this.selectedPageTitle);
        this.spinner.hide();
    }
  }

  getSearchValue() {
    switch (this.selectedPageTitle) {
      case 'Total Production Devices': {
        const searchProducedDevices = sessionStorage.getItem(
          'searchProducedDevices'
        );
        this.graphForm
          .get('searchProducedDevices')
          .setValue(searchProducedDevices ? searchProducedDevices : '');
        return this.graphForm.get('searchProducedDevices').value;
      }
      case 'Total Dispatched Devices': {
        const searchDispatchedDevices = sessionStorage.getItem(
          'searchDispatchedDevices'
        );
        this.graphForm
          .get('searchDispatchedDevices')
          .setValue(searchDispatchedDevices ? searchDispatchedDevices : '');
        return this.graphForm.get('searchDispatchedDevices').value;
      }
      case 'Total Installed Devices': {
        const searchInstalledDevices = sessionStorage.getItem(
          'searchInstalledDevices'
        );
        this.graphForm
          .get('searchInstalledDevices')
          .setValue(searchInstalledDevices ? searchInstalledDevices : '');
        return this.graphForm.get('searchInstalledDevices').value;
      }
      case 'Total Discarded Devices': {
        const searchDiscardedDevices = sessionStorage.getItem(
          'searchDiscardedDevices'
        );
        this.graphForm
          .get('searchDiscardedDevices')
          .setValue(searchDiscardedDevices ? searchDiscardedDevices : '');
        return this.graphForm.get('searchDiscardedDevices').value;
      }
      case 'Device Activity Overview': {
        const searchDevicesNotActiveFrom = sessionStorage.getItem(
          'searchDevicesNotActiveFrom'
        );
        this.graphForm
          .get('searchDevicesNotActiveFrom')
          .setValue(
            searchDevicesNotActiveFrom ? searchDevicesNotActiveFrom : ''
          );
        return this.graphForm.get('searchDevicesNotActiveFrom').value;
      }
      case 'Firmware Wise Devices': {
        const searchFirmwareWisedetails = sessionStorage.getItem(
          'searchFirmwareWisedetails'
        );
        this.graphForm
          .get('searchFirmwareWisedetails')
          .setValue(searchFirmwareWisedetails ? searchFirmwareWisedetails : '');
        return this.graphForm.get('searchFirmwareWisedetails').value;
      }
      case 'Boot loader Version Wise Devices': {
        const searchBootVersionWiseDetails = sessionStorage.getItem(
          'searchBootVersionWiseDetails'
        );
        this.graphForm
          .get('searchBootVersionWiseDetails')
          .setValue(
            searchBootVersionWiseDetails ? searchBootVersionWiseDetails : ''
          );
        return this.graphForm.get('searchBootVersionWiseDetails').value;
      }
      case 'MCU Version Wise Devices': {
        const searchMcuVersionWiseDetails = sessionStorage.getItem(
          'searchMcuVersionWiseDetails'
        );
        this.graphForm
          .get('searchMcuVersionWiseDetails')
          .setValue(
            searchMcuVersionWiseDetails ? searchMcuVersionWiseDetails : ''
          );
        return this.graphForm.get('searchMcuVersionWiseDetails').value;
      }
      case 'CPU Version Wise Devices': {
        const searchCpuVersionWiseDetails = sessionStorage.getItem(
          'searchCpuVersionWiseDetails'
        );
        this.graphForm
          .get('searchCpuVersionWiseDetails')
          .setValue(
            searchCpuVersionWiseDetails ? searchCpuVersionWiseDetails : ''
          );
        return this.graphForm.get('searchCpuVersionWiseDetails').value;
      }
      default:
        return '';
    }
  }

  fetchProductionData() {
    this.deviceApiService
      .getProductionData(
        this.currentPage,
        this.pageSize,
        this.searchText,
        this.selectedDeviceModelId,
        this.selectedCustomerId
      )
      .subscribe({
        next: (res) => this.handleResponse(res, 'Total Production Devices'),
        error: (error) => this.handleError(error),
      });
  }

  fetchDispatchData() {
    this.deviceApiService
      .getDispatchedData(
        this.currentPage,
        this.pageSize,
        this.searchText,
        this.selectedDeviceModelId,
        this.selectedCustomerId
      )
      .subscribe({
        next: (res) => this.handleResponse(res, 'Total Dispatched Devices'),
        error: (error) => this.handleError(error),
      });
  }

  fetchInstalledData() {
    this.deviceApiService
      .getInstalledDevices(
        this.currentPage,
        this.pageSize,
        this.searchText,
        this.selectedDeviceModelId,
        this.selectedCustomerId
      )
      .subscribe({
        next: (res) => this.handleResponse(res, 'Total Installed Devices'),
        error: (error) => this.handleError(error),
      });
  }

  fetchDiscardedData() {
    this.deviceApiService
      .getDiscardedDevices(
        this.currentPage,
        this.pageSize,
        this.searchText,
        this.selectedDeviceModelId,
        this.selectedCustomerId
      )
      .subscribe({
        next: (res) => this.handleResponse(res, 'Total Discarded Devices'),
        error: (error) => this.handleError(error),
      });
  }

  fetchDeviceActivityOverviewData() {
    this.graphForm
      .get('devicesNotActiveSortBy')
      ?.patchValue(sessionStorage.getItem('devicesNotActiveSortBy') ?? '');

    const devicesNotActiveSortBy = this.graphForm.get(
      'devicesNotActiveSortBy'
    )?.value;

    this.deviceApiService
      .fetchDeviceActivityOverviewData(
        this.currentPage,
        this.pageSize,
        this.searchText,
        devicesNotActiveSortBy,
        this.selectedDeviceModelId,
        this.selectedCustomerId
      )
      .subscribe({
        next: (res) => this.handleResponse(res, 'Device Activity Overview'),
        error: (error) => this.handleError(error),
      });
  }

  getFirmwareWiseDeviceList() {
    let firmwareWiseSortBy = sessionStorage.getItem('firmwareWiseSortBy');
    this.graphForm
      .get('firmwareWiseSortBy')
      .setValue(firmwareWiseSortBy ? firmwareWiseSortBy : '');
    firmwareWiseSortBy = this.graphForm.get('firmwareWiseSortBy').value;

    const firmwareVersion =
      firmwareWiseSortBy === 'All' ? '' : firmwareWiseSortBy;
    this.deviceApiService
      .getFirmwareWiseDeviceList(
        this.currentPage,
        this.pageSize,
        this.searchText,
        firmwareVersion,
        'SAMPARK',
        this.selectedDeviceModelId
      )
      .subscribe({
        next: (res) => this.handleResponse(res, 'Firmware Wise Devices'),
        error: (error) => this.handleError(error),
      });
  }

  getBootVersionWiseDeviceList() {
    let firmwareWiseSortBy = sessionStorage.getItem('firmwareWiseSortBy');
    this.graphForm
      .get('firmwareWiseSortBy')
      .setValue(firmwareWiseSortBy ? firmwareWiseSortBy : '');
    firmwareWiseSortBy = this.graphForm.get('firmwareWiseSortBy').value;

    const bootVersion = firmwareWiseSortBy === 'All' ? '' : firmwareWiseSortBy;
    this.deviceApiService
      .getFirmwareWiseDeviceList(
        this.currentPage,
        this.pageSize,
        this.searchText,
        bootVersion,
        'BOOT',
        this.selectedDeviceModelId
      )
      .subscribe({
        next: (res) =>
          this.handleResponse(res, 'Boot loader Version Wise Devices'),
        error: (error) => this.handleError(error),
      });
  }

  getMcuVersionWiseDeviceList() {
    let firmwareWiseSortBy = sessionStorage.getItem('firmwareWiseSortBy');
    this.graphForm
      .get('firmwareWiseSortBy')
      .setValue(firmwareWiseSortBy ? firmwareWiseSortBy : '');
    firmwareWiseSortBy = this.graphForm.get('firmwareWiseSortBy').value;

    const mcuVersion = firmwareWiseSortBy === 'All' ? '' : firmwareWiseSortBy;
    this.deviceApiService
      .getFirmwareWiseDeviceList(
        this.currentPage,
        this.pageSize,
        this.searchText,
        mcuVersion,
        'MCU',
        this.selectedDeviceModelId
      )
      .subscribe({
        next: (res) => this.handleResponse(res, 'MCU Version Wise Devices'),
        error: (error) => this.handleError(error),
      });
  }

  getCpuVersionWiseDeviceList() {
    let firmwareWiseSortBy = sessionStorage.getItem('firmwareWiseSortBy');
    this.graphForm
      .get('firmwareWiseSortBy')
      .setValue(firmwareWiseSortBy ? firmwareWiseSortBy : '');
    firmwareWiseSortBy = this.graphForm.get('firmwareWiseSortBy').value;

    const cpuVersion = firmwareWiseSortBy === 'All' ? '' : firmwareWiseSortBy;
    this.deviceApiService
      .getFirmwareWiseDeviceList(
        this.currentPage,
        this.pageSize,
        this.searchText,
        cpuVersion,
        'CPU',
        this.selectedDeviceModelId
      )
      .subscribe({
        next: (res) => this.handleResponse(res, 'CPU Version Wise Devices'),
        error: (error) => this.handleError(error),
      });
  }

  isFirmwareGraph(pageTitle: string) {
    return [
      'Firmware Wise Devices',
      'Boot loader Version Wise Devices',
      'MCU Version Wise Devices',
      'CPU Version Wise Devices',
    ].includes(pageTitle);
  }

  clearFirmwareGraphFilter() {
    this.graphForm.get('firmwareWiseSortBy').setValue('');
    sessionStorage.removeItem('firmwareWiseSortBy');
    this.setPageChangeValue(1);
  }

  searchTotalProductionDevice(event) {
    this.graphForm.get('searchProducedDevices').setValue(event);
    sessionStorage.setItem('searchProducedDevices', event);
    this.setPageChangeValue(1);
    this.fetchDeviceList('Total Production Devices');
  }

  searchDispatchedDevices(event) {
    this.graphForm.get('searchDispatchedDevices').setValue(event);
    sessionStorage.setItem('searchDispatchedDevices', event);
    this.setPageChangeValue(1);
    this.fetchDeviceList('Total Dispatched Devices');
  }

  searchInstalledDevices(event) {
    this.graphForm.get('searchInstalledDevices').setValue(event);
    sessionStorage.setItem('searchInstalledDevices', event);
    this.setPageChangeValue(1);
    this.fetchDeviceList('Total Installed Devices');
  }

  searchDiscardedDevices(event) {
    this.graphForm.get('searchDiscardedDevices').setValue(event);
    sessionStorage.setItem('searchDiscardedDevices', event);
    this.setPageChangeValue(1);
    this.fetchDeviceList('Total Discarded Devices');
  }

  searchDevicesNotActiveFrom(event) {
    this.graphForm.get('searchDevicesNotActiveFrom').setValue(event);
    sessionStorage.setItem('searchDevicesNotActiveFrom', event);
    this.setPageChangeValue(1);
    this.fetchDeviceList('Device Activity Overview');
  }

  searchDevicesFirmware(event) {
    switch (this.selectedPageTitle) {
      case 'Firmware Wise Devices':
        this.graphForm.get('searchFirmwareWisedetails').setValue(event);
        sessionStorage.setItem('searchFirmwareWisedetails', event);
        break;

      case 'Boot loader Version Wise Devices':
        this.graphForm.get('searchBootVersionWiseDetails').setValue(event);
        sessionStorage.setItem('searchBootVersionWiseDetails', event);
        break;

      case 'MCU Version Wise Devices':
        this.graphForm.get('searchMcuVersionWiseDetails').setValue(event);
        sessionStorage.setItem('searchMcuVersionWiseDetails', event);
        break;

      case 'CPU Version Wise Devices':
        this.graphForm.get('searchCpuVersionWiseDetails').setValue(event);
        sessionStorage.setItem('searchCpuVersionWiseDetails', event);
        break;
    }
    this.setPageChangeValue(1);
    this.fetchDeviceList(this.selectedPageTitle);
  }

  onDevicesNotActiveSelectionChange(event) {
    this.graphForm.get('devicesNotActiveSortBy').setValue(event);
    sessionStorage.setItem('devicesNotActiveSortBy', event);
    this.setPageChangeValue(1);
    this.fetchDeviceList('Device Activity Overview');
  }

  onDevicesFirmwareSelectionChange(event) {
    this.graphForm.get('firmwareWiseSortBy').setValue(event);
    sessionStorage.setItem('firmwareWiseSortBy', event);
    this.setPageChangeValue(1);
    this.fetchDeviceList(this.selectedPageTitle);
  }

  onCustomerNameSelectionChange(event) {
    this.graphForm.get('selectedCustomerId').setValue(event);
    sessionStorage.setItem('selectedCustomerId', event);
    this.selectedCustomerId = event;

    sessionStorage.removeItem('searchProducedDevices');
    sessionStorage.removeItem('searchDispatchedDevices');
    sessionStorage.removeItem('searchInstalledDevices');
    sessionStorage.removeItem('searchDiscardedDevices');
    sessionStorage.removeItem('searchDevicesNotActiveFrom');
    sessionStorage.removeItem('searchFirmwareWisedetails');
    sessionStorage.removeItem('searchBootVersionWiseDetails');
    sessionStorage.removeItem('searchMcuVersionWiseDetails');
    sessionStorage.removeItem('searchCpuVersionWiseDetails');

    sessionStorage.removeItem('devicesNotActiveSortBy');
    sessionStorage.removeItem('firmwareWiseSortBy');

    sessionStorage.removeItem('pageNumberProducedDevices');
    sessionStorage.removeItem('pageNumberDispatchedDevices');
    sessionStorage.removeItem('pageNumberInstalledDevices');
    sessionStorage.removeItem('pageNumberDiscardedDevices');
    sessionStorage.removeItem('pageNumberDevicesNotActiveFrom');
    sessionStorage.removeItem('pageNumberFirmwareWisedetails');
    sessionStorage.removeItem('pageNumberBootVersionWisedetails');
    sessionStorage.removeItem('pageNumberMcuVersionWisedetails');
    sessionStorage.removeItem('pageNumberCpuVersionWisedetails');

    sessionStorage.removeItem('pageSizeProducedDevices');
    sessionStorage.removeItem('pageSizeDispatchedDevices');
    sessionStorage.removeItem('pageSizeInstalledDevices');
    sessionStorage.removeItem('pageSizeDiscardedDevices');
    sessionStorage.removeItem('pageSizeDevicesNotActiveFrom');
    sessionStorage.removeItem('pageSizeFirmwareWisedetails');
    sessionStorage.removeItem('pageSizeBootVersionWisedetails');
    sessionStorage.removeItem('pageSizeMcuVersionWisedetails');
    sessionStorage.removeItem('pageSizeCpuVersionWisedetails');

    this.getDeviceDashboardKPICount();
    this.getDeviceDashboardGraphDetails();
    this.setPageChangeValue(1);
    this.setDeviceDashboardForm();
    this.fetchDeviceList(this.selectedPageTitle);
  }

  onDeviceModelNameSelectionChange(event) {
    this.graphForm.get('selectedDeviceModelId').setValue(event);
    sessionStorage.setItem('selectedDeviceModelId', event);
    this.selectedDeviceModelId = event;

    sessionStorage.removeItem('searchProducedDevices');
    sessionStorage.removeItem('searchDispatchedDevices');
    sessionStorage.removeItem('searchInstalledDevices');
    sessionStorage.removeItem('searchDiscardedDevices');
    sessionStorage.removeItem('searchDevicesNotActiveFrom');
    sessionStorage.removeItem('searchFirmwareWisedetails');
    sessionStorage.removeItem('searchBootVersionWiseDetails');
    sessionStorage.removeItem('searchMcuVersionWiseDetails');
    sessionStorage.removeItem('searchCpuVersionWiseDetails');

    sessionStorage.removeItem('devicesNotActiveSortBy');
    sessionStorage.removeItem('firmwareWiseSortBy');

    sessionStorage.removeItem('pageNumberProducedDevices');
    sessionStorage.removeItem('pageNumberDispatchedDevices');
    sessionStorage.removeItem('pageNumberInstalledDevices');
    sessionStorage.removeItem('pageNumberDiscardedDevices');
    sessionStorage.removeItem('pageNumberDevicesNotActiveFrom');
    sessionStorage.removeItem('pageNumberFirmwareWisedetails');
    sessionStorage.removeItem('pageNumberBootVersionWisedetails');
    sessionStorage.removeItem('pageNumberMcuVersionWisedetails');
    sessionStorage.removeItem('pageNumberCpuVersionWisedetails');

    sessionStorage.removeItem('pageSizeProducedDevices');
    sessionStorage.removeItem('pageSizeDispatchedDevices');
    sessionStorage.removeItem('pageSizeInstalledDevices');
    sessionStorage.removeItem('pageSizeDiscardedDevices');
    sessionStorage.removeItem('pageSizeDevicesNotActiveFrom');
    sessionStorage.removeItem('pageSizeFirmwareWisedetails');
    sessionStorage.removeItem('pageSizeBootVersionWisedetails');
    sessionStorage.removeItem('pageSizeMcuVersionWisedetails');
    sessionStorage.removeItem('pageSizeCpuVersionWisedetails');

    this.getDeviceDashboardKPICount();
    this.getDeviceDashboardGraphDetails();
    this.setPageChangeValue(1);
    this.setDeviceDashboardForm();
    this.fetchDeviceList(this.selectedPageTitle);
  }

  handleResponse(res, apiType) {
    if (res.status) {
      this.spinner.hide();
      this.totalCount = res.totalItems;
      this.totalPage = res.totalPages;
      this.currentPage = res.pageNumber;
      this.pageSize = res.pageSize;
      this.deviceDetailsList = res.data || [];
      this.selectedPageTitle = apiType;
      this.commonApiService.openSnackbar('Fetched Successfully');
    } else {
      this.spinner.hide();
      this.commonApiService.openSnackbar(res.message);
    }
  }

  handleError(error: HttpErrorResponse) {
    this.spinner.hide();
    this.commonApiService.openSnackbar(
      error.error.message || 'An error occurred'
    );
  }

  exportToExcelProductionDeviceData() {
    if (confirm('Are you sure?')) {
      this.exportData = [];
      this.deviceApiService
        .getProductionData(
          1,
          this.totalCount,
          this.searchText,
          this.selectedDeviceModelId,
          this.selectedCustomerId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.exportData = res.data;
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uid'],
                imei: item['imei'],
                iccid: item['iccid'],
                modelName: item['modelName'],
                chassisNo: item['chassisNo'],
                operatNo: item['operatNo'],
                mobile: item['mobile'],
                serviceProvider: item['serviceProvider'],
                altMobile: item['altMobile'],
                altServiceProvider: item['altServiceProvider'],
                bootstrapExpDate: item['bootstrapExpDate'],
                deviceStatusUpdateDate: item['deviceStatusUpdateDate'],
                modelSerialSequence: item['modelSerialSequence'],
                hardwareVersion: item['hardwareVersion'],
                installedAt: item['installedAt'],
                discardedAt: item['discardedAt'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'Production_Device_Data_'
              );
              this.spinner.hide();
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  exportToExcelDispatchedDeviceData() {
    if (confirm('Are you sure?')) {
      this.exportData = [];
      this.deviceApiService
        .getDispatchedData(
          1,
          this.totalCount,
          this.searchText,
          this.selectedDeviceModelId,
          this.selectedCustomerId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.exportData = res.data;
              console.log('exportData', this.exportData);
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uid'],
                imei: item['imei'],
                iccid: item['iccid'],
                modelName: item['modelName'],
                modelSerialSequence: item['modelSerialSequence'],
                hardwareVersion: item['hardwareVersion'],
                firmwareVersion: item['firmwareVersion'],
                customerName: item['customerName'],
                customerPartNumber: item['customerPartNumber'],
                mobile: item['mobile'],
                serviceProvider: item['serviceProvider'],
                altMobile: item['altMobile'],
                altServiceProvider: item['altServiceProvider'],
                operatNo: item['operatNo'],
                simVendor: item['simVendor'],
                bootstrapExpDate: item['bootstrapExpDate'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'Dispatched_Device_Details_'
              );
              this.spinner.hide();
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  exportToExcelInstalledDevices() {
    if (confirm('Are you sure?')) {
      this.exportData = [];
      this.deviceApiService
        .getInstalledDevices(
          1,
          this.totalCount,
          this.searchText,
          this.selectedDeviceModelId,
          this.selectedCustomerId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.exportData = res.data;
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uid'],
                imei: item['imei'],
                iccid: item['iccid'],
                modelName: item['modelName'],
                chassisNo: item['chassisNo'],
                installedAt: item['installedAt'],
                loggedInAt: item['login'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'Installed_Device_Details_'
              );
              this.spinner.hide();
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  exportToExcelDiscardedDevices() {
    if (confirm('Are you sure?')) {
      this.exportData = [];
      this.deviceApiService
        .getDiscardedDevices(
          1,
          this.totalCount,
          this.searchText,
          this.selectedDeviceModelId,
          this.selectedCustomerId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.exportData = res.data;
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uid'],
                imei: item['imei'],
                iccid: item['iccid'],
                modelName: item['modelName'],
                chassisNo: item['chassisNo'],
                loggedInAt: item['login'],
                installedAt: item['installedAt'],
                discardedAt: item['discardedAt'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'Discarded_Device_Details_'
              );
              this.spinner.hide();
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  exportToExcelDeviceNotActiveFromData() {
    if (confirm('Are you sure?')) {
      const devicesNotActiveSortBy = this.graphForm.get(
        'devicesNotActiveSortBy'
      ).value;
      this.exportData = [];
      this.deviceApiService
        .fetchDeviceActivityOverviewData(
          1,
          this.totalCount,
          this.searchText,
          devicesNotActiveSortBy,
          this.selectedDeviceModelId,
          this.selectedCustomerId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.spinner.hide();
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uid'],
                imei: item['imei'],
                iccid: item['iccid'],
                modelName: item['modelName'],
                login: item['login'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'Devices_Not_Active_From_'
              );
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  exportToExcelFirmwareWiseDetails() {
    if (confirm('Are you sure?')) {
      const firmwareWiseSortBy = sessionStorage.getItem('firmwareWiseSortBy');
      this.graphForm
        .get('firmwareWiseSortBy')
        .setValue(firmwareWiseSortBy ? firmwareWiseSortBy : '');
      const firmwareVersion =
        !firmwareWiseSortBy || firmwareWiseSortBy === 'All'
          ? ''
          : firmwareWiseSortBy;
      this.exportData = [];
      this.deviceApiService
        .getFirmwareWiseDeviceList(
          1,
          this.totalCount,
          this.searchText,
          firmwareVersion,
          'SAMPARK',
          this.selectedDeviceModelId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.spinner.hide();
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uin'],
                imei: item['imei'],
                iccid: item['iccid'],
                // modelName: item['modelName'],
                // login: item['login'],
                firmwareVersion: item['deviceFirmware'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'Firmware_Wise_Device_Details_'
              );
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  exportToExcelBootVersionWiseDetails() {
    if (confirm('Are you sure?')) {
      const firmwareWiseSortBy = sessionStorage.getItem('firmwareWiseSortBy');
      this.graphForm
        .get('firmwareWiseSortBy')
        .setValue(firmwareWiseSortBy ? firmwareWiseSortBy : '');
      this.exportData = [];
      const bootVersion =
        !firmwareWiseSortBy || firmwareWiseSortBy === 'All'
          ? ''
          : firmwareWiseSortBy;
      this.deviceApiService
        .getFirmwareWiseDeviceList(
          1,
          this.totalCount,
          this.searchText,
          bootVersion,
          'BOOT',
          this.selectedDeviceModelId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.spinner.hide();
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uin'],
                imei: item['imei'],
                iccid: item['iccid'],
                // modelName: item['modelName'],
                bootVersion: item['bootVersion'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'Boot_Version_Wise_Device_Details_'
              );
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  exportToExcelMcuVersionWiseDetails() {
    if (confirm('Are you sure?')) {
      const firmwareWiseSortBy = sessionStorage.getItem('firmwareWiseSortBy');
      this.graphForm
        .get('firmwareWiseSortBy')
        .setValue(firmwareWiseSortBy ? firmwareWiseSortBy : '');
      this.exportData = [];
      const mcuVersion =
        !firmwareWiseSortBy || firmwareWiseSortBy === 'All'
          ? ''
          : firmwareWiseSortBy;
      this.deviceApiService
        .getFirmwareWiseDeviceList(
          1,
          this.totalCount,
          this.searchText,
          mcuVersion,
          'MCU',
          this.selectedDeviceModelId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.spinner.hide();
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uin'],
                imei: item['imei'],
                iccid: item['iccid'],
                // modelName: item['modelName'],
                mcuVersion: item['mcuVersion'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'MCU_Version_Wise_Device_Details_'
              );
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  exportToExcelCpuVersionWiseDetails() {
    if (confirm('Are you sure?')) {
      const firmwareWiseSortBy = sessionStorage.getItem('firmwareWiseSortBy');
      this.graphForm
        .get('firmwareWiseSortBy')
        .setValue(firmwareWiseSortBy ? firmwareWiseSortBy : '');
      this.exportData = [];
      const cpuVersion =
        !firmwareWiseSortBy || firmwareWiseSortBy === 'All'
          ? ''
          : firmwareWiseSortBy;
      this.deviceApiService
        .getFirmwareWiseDeviceList(
          1,
          this.totalCount,
          this.searchText,
          cpuVersion,
          'CPU',
          this.selectedDeviceModelId
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.spinner.hide();
              this.exportData = res.data.map(({ ...item }) => ({
                uid: item['uin'],
                imei: item['imei'],
                iccid: item['iccid'],
                // modelName: item['modelName'],
                cpuVersion: item['cpuVersion'],
              }));
              this.commonApiService.createCSVFile(
                this.exportData,
                'CPU_Version_Wise_Device_Details_'
              );
              this.commonApiService.openSnackbar('File Ready For Download.');
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
    }
  }

  onPageChange(pageNumber) {
    this.spinner.show();
    this.currentPage = pageNumber;
    this.setPageChangeValue(pageNumber);
    this.fetchDeviceList(this.selectedPageTitle);
  }

  onSizeChange(newPageSize) {
    this.pageSize = newPageSize;
    this.currentPage = 1;
    this.setSizeChangeValue(newPageSize);
    this.onPageChange(1);
  }

  setPageChangeValue(pageNumber) {
    switch (this.selectedPageTitle) {
      case 'Total Production Devices': {
        sessionStorage.setItem('pageNumberProducedDevices', pageNumber);
        break;
      }
      case 'Total Dispatched Devices': {
        sessionStorage.setItem('pageNumberDispatchedDevices', pageNumber);
        break;
      }
      case 'Total Installed Devices': {
        sessionStorage.setItem('pageNumberInstalledDevices', pageNumber);
        break;
      }
      case 'Total Discarded Devices': {
        sessionStorage.setItem('pageNumberDiscardedDevices', pageNumber);
        break;
      }
      case 'Device Activity Overview': {
        sessionStorage.setItem('pageNumberDevicesNotActiveFrom', pageNumber);
        break;
      }
      case 'Firmware Wise Devices': {
        sessionStorage.setItem('pageNumberFirmwareWisedetails', pageNumber);
        break;
      }
      case 'Boot loader Version Wise Devices': {
        sessionStorage.setItem('pageNumberBootVersionWisedetails', pageNumber);
        break;
      }
      case 'MCU Version Wise Devices': {
        sessionStorage.setItem('pageNumberMcuVersionWisedetails', pageNumber);
        break;
      }
      case 'CPU Version Wise Devices': {
        sessionStorage.setItem('pageNumberCpuVersionWisedetails', pageNumber);
        break;
      }
      default:
        return '';
    }
  }

  setSizeChangeValue(pageSize) {
    switch (this.selectedPageTitle) {
      case 'Total Production Devices': {
        sessionStorage.setItem('pageSizeProducedDevices', pageSize);
        break;
      }
      case 'Total Dispatched Devices': {
        sessionStorage.setItem('pageSizeDispatchedDevices', pageSize);
        break;
      }
      case 'Total Installed Devices': {
        sessionStorage.setItem('pageSizeInstalledDevices', pageSize);
        break;
      }
      case 'Total Discarded Devices': {
        sessionStorage.setItem('pageSizeDiscardedDevices', pageSize);
        break;
      }
      case 'Device Activity Overview': {
        sessionStorage.setItem('pageSizeDevicesNotActiveFrom', pageSize);
        break;
      }
      case 'Firmware Wise Devices': {
        sessionStorage.setItem('pageSizeFirmwareWisedetails', pageSize);
        break;
      }
      case 'Boot loader Version Wise Devices': {
        sessionStorage.setItem('pageSizeBootVersionWisedetails', pageSize);
        break;
      }
      case 'MCU Version Wise Devices': {
        sessionStorage.setItem('pageSizeMcuVersionWisedetails', pageSize);
        break;
      }
      case 'CPU Version Wise Devices': {
        sessionStorage.setItem('pageSizeCpuVersionWisedetails', pageSize);
        break;
      }
      default:
        return '';
    }
  }

  getPageChangeValue() {
    switch (this.selectedPageTitle) {
      case 'Total Production Devices': {
        let page = 1;
        if (parseInt(sessionStorage.getItem('pageNumberProducedDevices'))) {
          page = parseInt(sessionStorage.getItem('pageNumberProducedDevices'));
        } else {
          sessionStorage.setItem('pageNumberProducedDevices', page.toString());
        }
        return page;
      }
      case 'Total Dispatched Devices': {
        let page = 1;
        if (parseInt(sessionStorage.getItem('pageNumberDispatchedDevices'))) {
          page = parseInt(
            sessionStorage.getItem('pageNumberDispatchedDevices')
          );
        } else {
          sessionStorage.setItem(
            'pageNumberDispatchedDevices',
            page.toString()
          );
        }
        return page;
      }
      case 'Total Installed Devices': {
        let page = 1;
        if (parseInt(sessionStorage.getItem('pageNumberInstalledDevices'))) {
          page = parseInt(sessionStorage.getItem('pageNumberInstalledDevices'));
        } else {
          sessionStorage.setItem('pageNumberInstalledDevices', page.toString());
        }
        return page;
      }
      case 'Total Discarded Devices': {
        let page = 1;
        if (parseInt(sessionStorage.getItem('pageNumberDiscardedDevices'))) {
          page = parseInt(sessionStorage.getItem('pageNumberDiscardedDevices'));
        } else {
          sessionStorage.setItem('pageNumberDiscardedDevices', page.toString());
        }
        return page;
      }
      case 'Device Activity Overview': {
        let page = 1;
        if (
          parseInt(sessionStorage.getItem('pageNumberDevicesNotActiveFrom'))
        ) {
          page = parseInt(
            sessionStorage.getItem('pageNumberDevicesNotActiveFrom')
          );
        } else {
          sessionStorage.setItem(
            'pageNumberDevicesNotActiveFrom',
            page.toString()
          );
        }
        return page;
      }
      case 'Firmware Wise Devices': {
        let page = 1;
        if (parseInt(sessionStorage.getItem('pageNumberFirmwareWisedetails'))) {
          page = parseInt(
            sessionStorage.getItem('pageNumberFirmwareWisedetails')
          );
        } else {
          sessionStorage.setItem(
            'pageNumberFirmwareWisedetails',
            page.toString()
          );
        }
        return page;
      }
      case 'Boot loader Version Wise Devices': {
        let page = 1;
        if (
          parseInt(sessionStorage.getItem('pageNumberBootVersionWisedetails'))
        ) {
          page = parseInt(
            sessionStorage.getItem('pageNumberBootVersionWisedetails')
          );
        } else {
          sessionStorage.setItem(
            'pageNumberBootVersionWisedetails',
            page.toString()
          );
        }
        return page;
      }
      case 'MCU Version Wise Devices': {
        let page = 1;
        if (
          parseInt(sessionStorage.getItem('pageNumberMcuVersionWisedetails'))
        ) {
          page = parseInt(
            sessionStorage.getItem('pageNumberMcuVersionWisedetails')
          );
        } else {
          sessionStorage.setItem(
            'pageNumberMcuVersionWisedetails',
            page.toString()
          );
        }
        return page;
      }
      case 'CPU Version Wise Devices': {
        let page = 1;
        if (
          parseInt(sessionStorage.getItem('pageNumberCpuVersionWisedetails'))
        ) {
          page = parseInt(
            sessionStorage.getItem('pageNumberCpuVersionWisedetails')
          );
        } else {
          sessionStorage.setItem(
            'pageNumberCpuVersionWisedetails',
            page.toString()
          );
        }
        return page;
      }
      default:
        return 1;
    }
  }

  getSizeChangeValue() {
    switch (this.selectedPageTitle) {
      case 'Total Production Devices': {
        let pageSize = 10;
        if (parseInt(sessionStorage.getItem('pageSizeProducedDevices'))) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeProducedDevices')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeProducedDevices',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      case 'Total Dispatched Devices': {
        let pageSize = 10;
        if (parseInt(sessionStorage.getItem('pageSizeDispatchedDevices'))) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeDispatchedDevices')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeDispatchedDevices',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      case 'Total Installed Devices': {
        let pageSize = 10;
        if (parseInt(sessionStorage.getItem('pageSizeInstalledDevices'))) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeInstalledDevices')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeInstalledDevices',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      case 'Total Discarded Devices': {
        let pageSize = 10;
        if (parseInt(sessionStorage.getItem('pageSizeDiscardedDevices'))) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeDiscardedDevices')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeDiscardedDevices',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      case 'Device Activity Overview': {
        let pageSize = 10;
        if (parseInt(sessionStorage.getItem('pageSizeDevicesNotActiveFrom'))) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeDevicesNotActiveFrom')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeDevicesNotActiveFrom',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      case 'Firmware Wise Devices': {
        let pageSize = 10;
        if (parseInt(sessionStorage.getItem('pageSizeFirmwareWisedetails'))) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeFirmwareWisedetails')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeFirmwareWisedetails',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      case 'Boot loader Version Wise Devices': {
        let pageSize = 10;
        if (
          parseInt(sessionStorage.getItem('pageSizeBootVersionWisedetails'))
        ) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeBootVersionWisedetails')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeBootVersionWisedetails',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      case 'MCU Version Wise Devices': {
        let pageSize = 10;
        if (parseInt(sessionStorage.getItem('pageSizeMcuVersionWisedetails'))) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeMcuVersionWisedetails')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeMcuVersionWisedetails',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      case 'CPU Version Wise Devices': {
        let pageSize = 10;
        if (parseInt(sessionStorage.getItem('pageSizeCpuVersionWisedetails'))) {
          pageSize = parseInt(
            sessionStorage.getItem('pageSizeCpuVersionWisedetails')
          );
        } else {
          sessionStorage.setItem(
            'pageSizeCpuVersionWisedetails',
            pageSize.toString()
          );
        }
        return pageSize;
      }
      default:
        return 10;
    }
  }

  view(uid, imei) {
    sessionStorage.setItem('uid', uid);
    sessionStorage.setItem('imei', imei);
    this.router.navigate(['device-details']);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
